import billingsTranslationsHelper from "../../../../../languages/billings-translations.helper";
import MetaBillingsCargoTaxiStatusCounters from "../../../../../common/services/meta/billings/cargo-taxi/status-counters/meta-billings-cargo-taxi-status-counters";
import BillingsCargoOrderListingItemBillingStatus from "./types/billings-cargo-order-listing-item-billing-status";
import BillingsCargoOrderListingStatusLegendOption from "./types/billings-cargo-order-listing-status-legend-option";

const getStatusText = (
  status: BillingsCargoOrderListingItemBillingStatus,
): string => {
  const translations =
    billingsTranslationsHelper.getCargoOrderBillingsListingTranslations()
      .status;

  switch (status) {
    case BillingsCargoOrderListingItemBillingStatus.CREATED:
      return translations.CREATED;
    case BillingsCargoOrderListingItemBillingStatus.ACCEPTED:
      return translations.ACCEPTED;
    case BillingsCargoOrderListingItemBillingStatus.REJECTED:
      return translations.REJECTED;
    case BillingsCargoOrderListingItemBillingStatus.REOPENED:
      return translations.REOPENED;
    case BillingsCargoOrderListingItemBillingStatus.REOPEN_REQUEST_SENT:
      return translations.REOPEN_REQUEST_SENT;
    default:
      return "";
  }
};

// IMPORTANT: field order has direct impact on status display order!
const getStatusOptions = (
  data?: MetaBillingsCargoTaxiStatusCounters,
): BillingsCargoOrderListingStatusLegendOption[] => {
  const translations =
    billingsTranslationsHelper.getCargoOrderBillingsListingTranslations()
      .status;

  const options: BillingsCargoOrderListingStatusLegendOption[] = [
    {
      label: translations.CREATED,
      status: BillingsCargoOrderListingItemBillingStatus.CREATED,
      totalCount: data?.total,
    },
    {
      label: translations.ACCEPTED,
      status: BillingsCargoOrderListingItemBillingStatus.ACCEPTED,
      totalCount: data?.accepted,
    },
    {
      label: translations.REJECTED,

      status: BillingsCargoOrderListingItemBillingStatus.REJECTED,
      totalCount: data?.rejected,
    },
    {
      label: translations.REOPEN_REQUEST_SENT,
      status: BillingsCargoOrderListingItemBillingStatus.REOPEN_REQUEST_SENT,
      totalCount: data?.reopenRequest,
    },
    {
      label: translations.REOPENED,
      status: BillingsCargoOrderListingItemBillingStatus.REOPENED,
      totalCount: data?.reopened,
    },
  ];

  return options;
};

const billingsCargoOrderListingHelper = {
  getStatusText,
  getStatusOptions,
};

export default billingsCargoOrderListingHelper;
